// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__13nSS","col":"styles_col__1MW7G"};